import axios from "axios";
import UidEmailRoleMatch from "../../../../constants/uidEmailRoleMatch";

export const getGstAddress = (gstNumber: string, sessionId: string | null) => {
  const UidEmailRole = UidEmailRoleMatch();

  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/read/many/tradexwbench.temp_gst_details`,
      {
        params: {
          ...UidEmailRole,
          filter: `[('gstin', '=',  '${gstNumber}')]`,
          query: "{id,bnm,st,bno,loc,stcd,pncd}",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
